export const MONTH = 1;
export const QUARTER = 3;
export const HALF_YEAR = 6;
export const YEAR = 12;

export default Object.freeze({
  MONTH,
  QUARTER,
  HALF_YEAR,
  YEAR
});
